// extracted by css-extract-rspack-plugin
export default {"overflow-list":"OverflowList_overflow-list__aySuB","overflow-list-spacer":"OverflowList_overflow-list-spacer__s6TaQ"};